import {TierType} from 'Types/incentiveTier/incentiveTierTypes';

export const isTimeTier = (tierType: TierType): boolean => {
  return (
    tierType === TierType.TIME ||
    tierType === TierType.TIME_VOLUME ||
    tierType === TierType.TIME_LOYALTY
  );
};

export const isFreeSharesTier = (tierType: TierType): boolean => {
  return (
    tierType === TierType.FREE_SHARES || tierType === TierType.FREE_SHARES_CODES
  );
};
